import React, { useEffect, useRef, useState } from 'react';

import {SimpleImage} from './image-simple.jsx';
import {IconPlay} from '$partials/icons';
import ReactPlayer from 'react-player';
import {
    MediaController,
} from 'media-chrome/react';
/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/media.d.ts').Video}
 */
const Video = ({
    height,
    onFullscreenChange,
    onPlayingStateChange,
    playButtonPosition = 'bottom-right',
    poster,
    src,
    title = '',
    width,
    autoPlay,
    loop,
    showControls = true,
}) => {
    const playerRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(autoPlay);
    const [showPoster, setShowPoster] = useState(true);
    const startPlay = () => {
        setIsPlaying(true);
    };

    useEffect(() => {
        if (isPlaying) {
            setShowPoster(false);
        }
    }, [isPlaying]);

    return (
        <MediaController
            style={{
                borderRadius: '8px',
                overflow: 'hidden',
                width: '100%',
                aspectRatio: width && height ? `${width}/${height}` : '16/9',
            }}>
            <ReactPlayer
                crossOrigin
                controls={showControls}
                light={
                    (autoPlay || !showPoster) ? false : <SimpleImage src={poster} />
                }
                loop={loop}
                muted={true}
                onEnded={() => setShowPoster(true)}
                onPlay={() => setShowPoster(false)}
                pip={false}
                playing={isPlaying}
                playsInline={true}
                ref={playerRef}
                slot='media'
                src={src}
                style={{
                    width: '100%',
                    height: '100%',
                }}
                title={title}>

            </ReactPlayer>
            {showPoster && showControls && (
                <div className={`absolute z-50
                        ${playButtonPosition === 'bottom-right' ? 'right-8 bottom-8' : ''}
                        ${playButtonPosition === 'center' ? 'left-0 right-0 text-center' : ''}
                    `}>
                    <button
                        className='p-12 inline-flex items-center type-style-7 bg-button-tint-surface rounded-full'
                        onClick={startPlay.bind(null)}
                        type='button'>
                        <IconPlay/>
                    </button>
                </div>
            )}
        </MediaController>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default Video;
